import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@gearbox-protocol/deploy-tools-ui";
import type { FC } from "react";

import { FileContentView } from "./FileContentView";

export interface FileViewDialogProps {
  file: File;
  onClose: () => void;
}

export const FileViewDialog: FC<FileViewDialogProps> = ({ file, onClose }) => {
  return (
    <Dialog modal open onOpenChange={open => !open && onClose()}>
      <DialogContent className="max-w-[calc(100%-64px)] w-[calc(100%-64px)] max-h-[calc(100%-64px)] h-[calc(100%-64px)] flex flex-col">
        <DialogHeader>
          <DialogTitle>{file.name}</DialogTitle>
        </DialogHeader>

        <FileContentView file={file} className="flex-1 min-h-0" />
      </DialogContent>
    </Dialog>
  );
};
